import { toast, Zoom } from "react-toastify"


export default function notify (msg, type='info') {
    toast[type](msg, { transition: Zoom })
}